import { Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { EmployeeCostsService } from "../../employee-costs.service";
import { CollaboratorsService } from "../../../collaborators/collaborators.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-employee-tfr-amount",
  templateUrl: "./employee-tfr-amount.component.html",
  styleUrls: [],
})
export default class EmployeeTfrAmountComponent implements OnInit {
  contentHeader: IContentHeader;
  last_update: string;
  private currentTFRList: any = [];
  filterKeyword: string = "";
  filteredTFRList: any = [];
  findErrors: string[] = [];
  updateErrors: string[] = [];
  fileName: string;
  fileContent: any[] = [];
  openedErrorTab: string = "";
  private employees: any = [];

  constructor(
    public _utilService: UtilsService,
    private _userService: UserService,
    private _employeeCostsService: EmployeeCostsService,
    private collaboratorService: CollaboratorsService,
    private _authService: AuthenticationService,
    private router: Router,
  ) {
    this.contentHeader = {
      headerTitle: "EMPLOYEE_TFR_AMOUNT",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "EMPLOYEE_TFR_AMOUNT",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authService.hasCapability("update_employee_tfr_amount")) {
      return this.router.navigateByUrl("/dashboard/platform-management");
    }
    this.employees = await this._userService.getList("employee,ex-employee", null, true, "complete_name,hash,fiscal_code").then(async (results: any) => {
      const collaborators: any = await this.collaboratorService.getCollaboratorList();
      return [...results, ...collaborators];
    });

    this.currentTFRList = await this._employeeCostsService.getEmployeesTFR().then((results) => {
      this.filteredTFRList = results;
      return results;
    });
  }

  searchSaved() {
    const keyword = this.filterKeyword.toLowerCase().trim();
    this.filteredTFRList = this.currentTFRList.filter((item: any) => item.lastname.toLowerCase().includes(keyword) || item.firstname.toLowerCase().includes(keyword));
  }

  handlerChangeFileInput($event: any) {
    this._utilService.showLoading();
    const files = $event.target.files;
    if (!!files && files.length && files[0]) {
      this.fileName = files[0].name;
      this._utilService.parseXLSX(
        $event.target.files[0],
        [
          "Cod ditta",
          "Rag sociale",
          "Pos INPS",
          "Centro di costo",
          "Descr Centro di costo",
          "Sede lavoro",
          "Descr sede lavoro",
          "Raggruppamento 1",
          "Descr Raggruppamento 1",
          "Raggruppamento 2",
          "Descr Raggruppamento 2",
          "Periodo",
          "Cod dipendente",
          "Cognome e nome",
          "Data assunzione",
          "Data fine rapporto",
          "Data anzianita'",
          "Retrib utile erogata 25",
          "Mens suppl da erogare",
          "Quota TFR anno 25",
          "Contr aggiuntivo",
          "Quota vers Fondo Pensione",
          "Quota vers Fondo Tesoreria",
          "Riv.fondo TFR Azienda",
          "Riv.fondo TFR Tesoreria",
          "Riv.anticipazione Azienda",
          "Riv.anticipazione Tesoreria",
          "Quota acc.TFR 25 Azienda",
          "Quota acc.TFR 25 Tesoreria",
          "Costo tot quota 25",
          "Fondo TFR lordo al 31/12/24",
          "Quota F.do Tesorer. 31/12/24",
          "Imposta rival.TFR 24 Azienda",
          "Imposta rival.TFR 24 Tesoreria",
          "Quota accant. TFR 25 Azienda",
          "Quota accant. TFR 25 Tesoreria",
          "Anticipazioni TFR Azienda",
          "Anticipazioni TFR Tesoreria",
          "Acconti liquidati 25",
          "Acconti anni precedenti",
          "F.do lordo 31/08/25 Azienda",
          "F.do lordo 31/08/25 Tesoreria",
          "Imposta rival.TFR 25 Azienda",
          "Imposta rival.TFR 25 Tesoreria",
          "TFR liquidato 25 Azienda",
          "TFR liquidato 25 Tesoreria",
          "F.do netto 31/08/25 Azienda",
          "F.do netto 31/08/25 Tesoreria",
          "Anticip. anni prec. Azienda",
          "Anticip. anni prec. Tesoreria",
          "TFR Azienda trasferito pass.soc",
          "TFR Tesoreria trasferito pass.soc",
          "F.Tes: Contr versati nell'anno",
          "F.Tes: Contr versati anni prec",
          "F.Tes: Rivalutazione maturata",
          "F.Tes: Imposta rivalutaz maturata",
          "F.Tes: Contr recuperati anno",
          "F.Tes: Contr recuperati anni prec",
          "TFR c/INPS per CIGS/Solidarieta'",
          "TFR c/INPS CIGS/Sol. pag.dir.INPS",
          "F.Tes: Contr non recup per incap",
          "Raggruppamento contabile",
          "Descr Raggruppamento contabile",
          "F.Tes: Riversam contr aggiuntivo",
          "Codice lavoratore",
          "Codice fiscale",
        ],
        {
          raw: true,
          defval: 0,
          header: [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "AA",
            "AB",
            "AC",
            "AD",
            "AE",
            "AF",
            "AG",
            "AH",
            "AI",
            "AJ",
            "AK",
            "AL",
            "AM",
            "AN",
            "AO",
            "AP",
            "AQ",
            "AR",
            "AS",
            "AT",
            "AU",
            "AV",
            "AW",
            "AX",
            "AY",
            "AZ",
            "BA",
            "BB",
            "BC",
            "BD",
            "BE",
            "BF",
            "BG",
            "BH",
            "BI",
            "BJ",
            "BK",
            "BL",
            "BM",
            "BN",
          ],
        },
        async (data: any) => {
          const errorMessage: string = await this._utilService.translate("EMPLOYEE_NOT_FOUND");

          this.fileContent = data
            .slice(1)
            .map((item: any) => {
              const searchEmployee: any = this.employees.find((employee: any) => employee.fiscal_code === item["Codice fiscale"]);
              if (!searchEmployee) {
                this.findErrors.push(`${item["Cognome e nome"]}: ${errorMessage}`);
                return null;
              }

              const tfr = Number(item["F.do netto 31/08/25 Azienda"])

              return { complete_name: `${searchEmployee.lastname} ${searchEmployee.firstname}`, hash: searchEmployee.hash, tfr };
            })
            .filter((item: any) => item);

          this._utilService.hideLoading();
          return true;
        },
        "Foglio1",
      );
    }
  }

  async save() {
    this.updateErrors = [];
    const data = this.fileContent.map((item: any) => ({ hash: item.hash, tfr: item.tfr }));
    this._utilService.showLoading();
    await this._employeeCostsService.updateEmployeesTFR(data).then(async (result: any) => {
      this._utilService.hideLoading();
      if (result.hash_errors && result.hash_errors.length) {
        result.hash_errors.map((hash: string) => {
          const employee = this.employees.find((employee: any) => employee.hash === hash);
          this.updateErrors.push(employee);
        });
        await this._utilService.showToastrError("ERROR_UPDATING_EMPLOYEES_TFR_AMOUNT");
      } else {
        await this._utilService.showToastrSuccess("SUCCESS_UPDATING_EMPLOYEES_TFR_AMOUNT");
      }
    });
  }
}
